import Box from "@mui/material/Box";
import React from "react";
import {FormControl, FormHelperText} from "@mui/material";
import Typography from "@mui/material/Typography";
import DatePicker from "react-datepicker";
import {getTimeZoneFormated} from "../../../api/timeZone";

export default (data, key) => {
    return (<FormControl fullWidth key={key} error={data.error ? true : false}>
        <Box fullWidth style={{padding: '10px 0'}}>
            <Typography>
                {data.headerName}
            </Typography>
            <DatePicker
                key={key}
                id={`${data.name}-${key}`}
                name={data.name}
                selected={data.value}
                onChange={(e) => {
                    data.onCallback({target: {
                            name: data.name,
                            value: e
                        }})
                }}
            />
            {data.name === 'from' ? <Typography>Starting from the selected date {getTimeZoneFormated(data.value)} timezone</Typography> : ''}
            {data.name === 'until' ? <Typography>Until the selected date {getTimeZoneFormated(data.value)} timezone (excluded)</Typography> : ''}
            {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
        </Box>
    </FormControl>)
}

